import React, { useEffect, useState } from "react";
import { FaCheck, FaTimes } from "react-icons/fa";
import styled from "styled-components";

const EditableDiv = ({ Title, handleEdit, id, setapicalSignal }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [content, setContent] = useState(Title);

  useEffect(() => {
    setContent(Title || "-");
  }, [Title]);

  const handleClick = () => {
    setIsEditing(true);
  };

  const handleBlur = (e) => {
    setContent(e.target.innerText);
    setapicalSignal(true);
    setTimeout(() => {
      setIsEditing(false);
    }, 200);
    // handleEdit({
    //   variables: {
    //     id: id,
    //     userInput: { Title: content },
    //   },
    // });
  };

  return (
    // <OutsideClick setToggled={setIsEditing}>
    <Container>
      <Header> Title</Header>
      <EditableContent
        contentEditable={isEditing}
        onClick={handleClick}
        onBlur={handleBlur}
        suppressContentEditableWarning={true}
        isEditing={isEditing}
      >
        {content}
      </EditableContent>
      {isEditing && (
        <EditButtons>
          <IconButton
            onClick={async () => {
            
              await handleEdit({
                variables: {
                  id: id,
                  userInput: { Title: content },
                },
              });
              setIsEditing(false);
            }}
          >
            <FaCheck size={15} />
          </IconButton>
          <IconButton
            onClick={async () => {
            
              // await handleEdit({
              //   variables: {
              //     id: id,
              //    userInput:{ Description: content},
              //   },
              // });
              setIsEditing(false);
            }}
          >
            <FaTimes size={15} />
          </IconButton>
        </EditButtons>
      )}
    </Container>
    // </OutsideClick>
  );
};

export default EditableDiv;

const Container = styled.div`
  font-size: 18px;
  font-weight: 500;
  color: #172b4d;
  padding-bottom: 5px;
`;

const EditableContent = styled.div`
  border: ${(props) => (props.isEditing ? "1px solid #3367d1" : "none")};
  padding: 5px;
  white-space: pre-wrap; /* Preserve whitespace and line breaks */
  line-height: 1.3;
`;
const EditButtons = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
`;
const IconButton = styled.button`
  border: none;
  color: #42526e;
  background: #ffffff;
  border-radius: 3px;
  height: 30px;
  width: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-left: 4px; // Space between buttons
  box-shadow: 0 2px 0 rgba(9, 30, 66, 0.25);

  &:hover {
    background-color: #ebecf0;
  }

  &:active {
    background-color: #dfe1e6;
  }
`;
const Header = styled.div`
  font-size: 14px;
  color: #42526e;
`;
